import {Modal} from "react-bootstrap";
import MDButton from "../../components/MDButton";
import QRCode from "react-qr-code";
import {formatCurrency} from "../common/Utils";
import React, {useContext, useEffect, useState} from "react";
import {AppContext} from "../../lib/AppContext";
import PrintIcon from '@mui/icons-material/Print';

export default function WaiverQrCode({inventory, show, handleClose}) {
  const [context, setContext] = useContext(AppContext);

  const printGiftCard = () => {
    const content = document.getElementById("gift-card").innerHTML;
    const printWindow = window.open('', '', 'width=800,height=600');
    printWindow.document.write(`
                                              <html>
                                              <head>
                                                  <title>Print</title>
                                                  <style>
                                                      body { font-family: Arial, sans-serif; padding: 20px; font-size:0.9rem; line-height:0.9rem; }
                                                      p{margin:0; padding:0; line-height:13px; font-size:12px;}
                                                      h1,h2,h3,h4,h5,h6{font-size:14px; margin:0; padding:0; line-height:15px}
                                                      .no-print { display: none !important; }
                                                  </style>
                                              </head>
                                              <body onload="window.print(); window.close();">
                                                   ${content}
                                              </body>
                                              </html>
                                            `);
    printWindow.document.close();
  }

  return (
    <Modal onHide={handleClose} size={'lg'} show={show}>
      <Modal.Header closeButton>
        <Modal.Title>Guest Waiver</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{
      }}>

        <div style={{
        }} id={"gift-card"}>
          <div style={{
            width: '100%',
          }}>
            <div id="event-qr-code">
              <div style={{
                width: '40%',
                margin: '0 auto'
              }}>
                <QRCode
                  size={256}
                  style={{height: "auto", maxWidth: "100%", width: "100%"}}
                  value={inventory?.waiverUrl}
                  viewBox={'0 0 256 256'}/>
              </div>
            </div>
          </div>

          <center>
            <p className={'mt-2'}>
              <p>{inventory?.name} Event waiver</p>
              <p><a href={inventory?.waiverUrl} target={"_blank"}>{inventory?.waiverUrl}</a></p>
            </p>
          </center>

        </div>

        <MDButton type="button" color="primary" size={"small"} className={'my-3 mx-4'} onClick={() => {
          printGiftCard()
        }}>
          <PrintIcon/>&nbsp;Print
        </MDButton>

      </Modal.Body>

      <Modal.Footer>

        <MDButton type="button" color="info" onClick={() => {
          handleClose()
        }}>
          Close
        </MDButton>
      </Modal.Footer>
    </Modal>
  );
}